import React from "react";

//impport elementos de react
import { Row, Col, Pagination } from "react-bootstrap";

//import componentes y vistas
import { Image } from "react-bootstrap";
//import Imagenes
import ciudadano from "../../img/CRESE/ciudadano.png";
import ecosistemico from "../../img/CRESE/ecosistemico.png";
import emprendimiento from "../../img/CRESE/emprendimiento.png";
import genero from "../../img/CRESE/genero.png";
import pazComunidad from "../../img/CRESE/paz-comunidad.png";
import prosperidad from "../../img/CRESE/prosperidad.png";
import tecnologico from "../../img/CRESE/tecnologico.png";

import { POST_AXIOS } from "../funtionsREST";

export interface Props {
  Arrayresources: string[];
  grade: number;
  subject: string;
  description: string;
}

export default class CreseActivities extends React.Component<
  Props,
  {
    imagResourcesPrintable: Record<string, string>;
    resources: string[];
    currentPage: number;
    elementPage: number;
  }
> {
  constructor(props: Props) {
    super(props);
    this.state = {
      imagResourcesPrintable: {
        CIUDADANO: ciudadano,
        ECOSISTEMICO: ecosistemico,
        EMPRENDIMIENTO: emprendimiento,
        GÉNERO: genero,
        "PAZ Y COMUNIDAD": pazComunidad,
        "PROSPERIDAD  S1": prosperidad,
        "PROSPERIDAD  S2": prosperidad,
        "PROSPERIDAD  S3": prosperidad,
        TECNOLÓGICO: tecnologico,
      },

      resources: this.props.Arrayresources,
      currentPage: 1,
      elementPage: 6,
    };
    this.handleClick = this.handleClick.bind(this);
  }

  // Función que limpia el dominio incorrecto o faltante
  cleanUrl(url: string): string {
    // Verifica si la URL comienza con "www." y no tiene el "https://"
    if (url.startsWith("www.")) {
      return `https://${url}`; // Añade https:// al inicio si falta
    }
    return url; // Si ya tiene el protocolo https://, lo deja intacto
  }

  handleClick(event: any) {
    event.preventDefault();
    this.setState({ currentPage: Number(event.target.id) });
  }

  postProgressResource(resource_id: any) {
    let dataResource = {
      resource_id: resource_id,
    };
    POST_AXIOS("users/newResource", dataResource)
      .then((res) => {
        console.log("Progreso registrado correctamente:", res);
      })
      .catch((err) => {
        console.log("Error al registrar progreso:", err);
      });
    console.log("Nombre del recurso: ", dataResource);
  }

  render() {
    const { resources, currentPage, elementPage, imagResourcesPrintable } =
      this.state;
    const { description } = this.props;

    //-----------------------------Paginación-----------------------------------
    const indexOfLastTodo = currentPage * elementPage;
    const indexOfFirstTodo = indexOfLastTodo - elementPage;
    const currentResources = resources.slice(indexOfFirstTodo, indexOfLastTodo);

    let active = currentPage;
    let numberPages = Math.ceil(resources.length / elementPage);
    let items = [];
    for (let number = 1; number <= numberPages; number++) {
      items.push(
        <Pagination.Item
          key={number}
          id={number}
          active={number === active}
          onClick={this.handleClick}
        >
          {number}
        </Pagination.Item>
      );
    }

    const paginationBasic = (
      <div>
        <Pagination>{items}</Pagination>
        <br />
      </div>
    );
    //---------------------------------------------------------------------------------
    return (
      <div>
        <Row className="w-100 m-0 h-100 pt-5">
          <Col
            className="justify-content-center align-self-center text-center p-3"
            md={4}
          >
            <div className="af-lineOrange"></div>
          </Col>
          <Col className="m-0 p-0" md={4}>
            <h2 className="af-tittleLesson">Actividades CRESE</h2>
          </Col>
          <Col
            className="justify-content-center align-self-center text-center p-3"
            md={4}
          >
            <div className="af-lineOrange"></div>
          </Col>
        </Row>

        <Row>
          <p className="af-textComponent p-4">{description}</p>

          {currentResources.map((resour: any, i: any) => {
            let imageName = resour.resource_name;
            let cleanResourceUrl = this.cleanUrl(resour.resource_url);

            return (
              <Col key={resour.id} md={4}>
                {/* Llamada a la función de progreso cuando se clica el recurso */}
                <div onClick={() => this.postProgressResource(resour.id)}>
                  <div className="mb-2">
                    <a
                      href={cleanResourceUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Image
                        className="w-100"
                        src={imagResourcesPrintable[imageName]}
                      />
                    </a>
                  </div>
                  <div>
                    <p className="af-textLesson">
                      <strong>{`AI ${i + 1 + indexOfFirstTodo}.`} </strong>
                      {resour.dba_name}
                    </p>
                  </div>
                  <div></div>
                </div>
              </Col>
            );
          })}

          {resources.length > elementPage && (
            <Row className="w-100 justify-content-center align-self-center text-center">
              {paginationBasic}
            </Row>
          )}
        </Row>
      </div>
    );
  }
}
